import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AddGeoWishFromCandidateResponse
  extends BackendResponse {}
export interface AddGeoWishFromCandidateParameters
  extends NextApiParams {
  municipalityId: number;
  countyId: number;
}

export const addGeoWishFromCandidate = withNextApi<
  AddGeoWishFromCandidateResponse,
  AddGeoWishFromCandidateParameters
>("/cvp/CvpAddGeoWishToCandidate");
